<template>
    <div class="page newpage">
        <el-table :data="list" stripe :header-cell-style="{ background:'#f5f5f5'}">
            <el-table-column prop="id" label="序号"></el-table-column>
            <el-table-column prop="name" label="阶段" >
                <template slot-scope="scope">
                    {{ scope.row.pid == 0 ? scope.row.name : '' }}
                </template>
            </el-table-column>
            <el-table-column prop="group_name" label="层级" >
                <template slot-scope="scope">
                    {{ scope.row.pid > 0 ? scope.row.name : '' }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="300px" align="center">
                <template slot-scope="scope">
                    <div style="display: flex;justify-content: flex-end;">
                        <el-button size="small" type="success" v-if="scope.row.pid == 0" v-permit="'/admin/crm/levelAdd'" @click="openEditor('添加层级', scope.row)">添加层级</el-button>
                        <el-button size="small" type="primary" v-permit="'/admin/crm/levelEdit'" @click="openEditor('编辑', null, scope.row)">编辑</el-button>
                        <el-button size="small" type="danger" v-if="scope.row.pid != 0" v-permit="'/admin/crm/levelDel'" @click="handleDel(scope.row.id)">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
		
		<el-dialog :title="formData.title" :visible="show" width="1000px" center destroy-on-close @close="show=false">
		  <el-form label-position="right" label-width="100px" :model="formData" class="pr_20">
		    <el-form-item label="一级名称：">
                <el-input v-model="formData.name" v-if="formData.pid == 0"></el-input>
                <span v-else>{{formData.parent}}</span>
		    </el-form-item>
            <el-form-item label="名称：" v-if="formData.pid > 0">
                <el-input v-model="formData.name"></el-input>
		    </el-form-item>
		    <el-form-item label="说明：">
		        <el-input v-model="formData.desc"></el-input>
		    </el-form-item>
            <el-form-item label="跟进状态："  v-if="formData.pid == 0">
                <el-checkbox-group v-model="formData.follow_state">
                    <el-checkbox v-for="(item,index) in follow_state_map" :key="index" :label="item.code">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="自动回收："  v-if="formData.pid == 0">
                <div style="display: flex;flex-direction: column;width: 300px;">
                    <div>时间范围：<el-input-number v-model="formData.recycle.days" :min="0" :max="999999" controls-position="right" clearable style="width: 120px;margin-right: 10px;"></el-input-number>天内</div>
                    <el-checkbox v-model="formData.recycle.no_follow" true-label="1" false-label="0">无跟进行为</el-checkbox>
                    <el-checkbox v-model="formData.recycle.no_order" true-label="1" false-label="0">无订单发生</el-checkbox>
                    <div>回收到记录部门<!-- <span class="c9 ml_20">(跟进状态更新为待分配)</span> --></div>
                    <div><el-checkbox v-model="formData.recycle.clear_follow" true-label="1" false-label="0">回收后清空跟进记录</el-checkbox></div>
                </div>
            </el-form-item>
            <el-form-item label="触发：" v-if="formData.pid > 0">
                <el-radio-group v-model="formData.trigger">
                    <el-radio :label="1">自动更新</el-radio>
                    <el-radio :label="2">手动指定</el-radio>
                </el-radio-group>
                <div v-if="formData.trigger == 2">由员工在跟进过程中，选中本层级，允许多选。 并更新该用户阶段为层级所在阶段。</div>
                <div v-else>
                    <div>新业务订单时或每天03点，系统自动判断以下条件， 当满足条件时，即用户信息更新为该层级。</div>
                    <div>
                        <el-checkbox v-model="formData.upgrade.order_count_all_switch" true-label="1" false-label="0">历史订单数量累计：</el-checkbox>
                        <el-input v-model="formData.upgrade.order_count_all_min" style="width: 100px;"></el-input>到
                        <el-input v-model="formData.upgrade.order_count_all_max" style="width: 100px;"></el-input>单，订单类型为
                        <el-select placeholder="商品类型" v-model="formData.upgrade.order_count_all_type" multiple clearable style="width: 200px;">
                            <el-option label="标准单" value="1"></el-option>
                            <el-option label="定制单" value="4"></el-option>
                            <el-option label="礼品单" value="5"></el-option>
                            <el-option label="赠品单" value="6"></el-option>
                        </el-select>
                    </div>
                    <div>近 <el-input v-model="formData.upgrade.days" style="width: 100px;"></el-input> 天内的订单：</div>
                    <div>
                        <el-checkbox v-model="formData.upgrade.order_count_switch" true-label="1" false-label="0">订单数量累计：</el-checkbox>
                        <el-input v-model="formData.upgrade.order_count_min" style="width: 100px;"></el-input>到
                        <el-input v-model="formData.upgrade.order_count_max" style="width: 100px;"></el-input>单，订单类型为
                        <el-select placeholder="类型" v-model="formData.upgrade.order_count_type" multiple clearable style="width: 200px;">
                            <el-option label="标准单" value="1"></el-option>
                            <el-option label="定制单" value="4"></el-option>
                            <el-option label="礼品单" value="5"></el-option>
                            <el-option label="赠品单" value="6"></el-option>
                        </el-select>
                    </div>
                    <div style="margin-top: 10px;">
                        <el-checkbox v-model="formData.upgrade.order_amount_switch" true-label="1" false-label="0">订单金额累计：</el-checkbox>
                        <el-input v-model="formData.upgrade.order_amount_min" style="width: 100px;"></el-input>到
                        <el-input v-model="formData.upgrade.order_amount_max" style="width: 100px;"></el-input>元，订单类型为
                        <el-select placeholder="类型" v-model="formData.upgrade.order_amount_type" multiple clearable style="width: 200px;">
                            <el-option label="标准单" value="1"></el-option>
                            <el-option label="定制单" value="4"></el-option>
                            <el-option label="礼品单" value="5"></el-option>
                            <el-option label="赠品单" value="6"></el-option>
                        </el-select>
                    </div>
                    <div style="margin-top: 10px;">
                        <el-checkbox v-model="formData.upgrade.refund_amount_switch" true-label="1" false-label="0">退单金额累计：</el-checkbox>
                        <el-input v-model="formData.upgrade.refund_amount_min" style="width: 100px;"></el-input>到
                        <el-input v-model="formData.upgrade.refund_amount_max" style="width: 100px;"></el-input>元，订单类型为
                        <el-select placeholder="类型" v-model="formData.upgrade.refund_amount_type" multiple clearable style="width: 200px;">
                            <el-option label="标准单" value="1"></el-option>
                            <el-option label="定制单" value="4"></el-option>
                            <el-option label="礼品单" value="5"></el-option>
                            <el-option label="赠品单" value="6"></el-option>
                        </el-select>
                    </div>
                </div>
            </el-form-item>
		  </el-form>
            <span slot="footer">
                <el-button @click="show = false">取 消</el-button>
                <el-button type="primary" @click="submit" :loading="loading">确 定</el-button>
            </span>
		</el-dialog>
    </div>
</template>
<script>
import {
    adminLists, adminDetail, adminAdd, adminEdit, adminDisable, adminDel, adminSetDefaultPassword, adminResetLogin, roleLists,
    DepartmentLists, DepartmentAdd, DepartmentEdit, DepartmentDel,
    levelLists, levelAdd, levelEdit, levelDel,
} from "@/request/apis.js"
export default{
    data(){
        return {
			name:'',
            list : [],
			show : false,
            formDataInit: {},
            formData: {
                title: '创建',
                id: '',
                pid: 0,
                parent: '',
                name: '',
                desc: '',
                follow_state: [],
                recycle: {
                    days: '',
                    no_follow: '1',
                    no_order: '1',
                    clear_follow: '0',
                },
                trigger: 2,
                upgrade: {
                    order_count_all_switch: '0',
                    order_count_all_min: '',
                    order_count_all_max: '',
                    order_count_all_type: '',
                    days: '',
                    order_count_switch: '0',
                    order_count_min: '',
                    order_count_max: '',
                    order_count_type: '',
                    order_amount_switch: '0',
                    order_amount_min: '',
                    order_amount_max: '',
                    order_amount_type: '',
                    refund_amount_switch: '0',
                    refund_amount_min: '',
                    refund_amount_max: '',
                    refund_amount_type: '',
                },
            },
			departArr:[],
            loading: false,
            follow_state_map: [],
        }
    },
	mounted() {
        this.formDataInit = JSON.parse(JSON.stringify(this.formData));
        this.getlevelLists();
	},
	methods:{
        async getlevelLists(){
            var res = await levelLists();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.list = res.data;
            this.follow_state_map = res.other.follow_state;
        },
        async openEditor(title, data, detail){
            this.formData = Object.assign(JSON.parse(JSON.stringify(this.formDataInit)), {pid: data ? data.id : 0, parent: data ? data.name : '', title});
            if(detail && detail.id){
                this.formData = Object.assign(JSON.parse(JSON.stringify(this.formData)), detail);
            }
            this.show = true;
        },
        async handleDel(id){
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await levelDel({id});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg || '删除成功');
                this.getlevelLists();
            }).catch(() => {});
        },
        async submit(){
            let res;
            this.loading = true;
            if(this.formData.id){
                res = await levelEdit(this.formData);
            }else{
                res = await levelAdd(this.formData);
            }
            this.loading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg || '保存成功！');
            this.show = false;
            this.getlevelLists();
        },
	}
}
</script>

<style  scoped>
</style> 